import { BroadcastChannel } from 'broadcast-channel';
import { themeChannelName } from '../constants/ChannelConstants';
import { ApolloSettingKey } from '../constants/SettingConstants';
import { darkMediaQuery, defaultTheme, highContrastMediaQueries, themeList, themeStorageKey, } from '../constants/ThemeConstants';
import { MediaQueryListener } from './MediaQueryUtil';
import { get, put, } from './RequestUtil';
import { getSetting } from './SettingUtil';
import { caseInsensitiveCompare } from './StringUtil';
let themeChannelOut = null;
function createThemeChannel() {
    return new BroadcastChannel(themeChannelName);
}
export function getAutoThemeValue(includeHighContrast = false) {
    const isDarkMode = MediaQueryListener.getSnapshot(darkMediaQuery);
    if (includeHighContrast) {
        const isHighContrastMode = highContrastMediaQueries.some(highContrastMediaQuery => MediaQueryListener.getSnapshot(highContrastMediaQuery));
        if (isHighContrastMode) {
            return isDarkMode ? 'dark-hc' : 'light-hc';
        }
    }
    return isDarkMode ? 'dark' : 'light';
}
export function getApolloThemeFromTheme(theme, includeHighContrast = false) {
    if (theme === 'autoTheme') {
        return getAutoThemeValue(includeHighContrast);
    }
    return themeList.includes(theme) ? theme : 'light';
}
function messageThemeChannel(theme) {
    if (!themeChannelOut) {
        themeChannelOut = createThemeChannel();
    }
    themeChannelOut.postMessage(theme);
}
export function validateThemeCode(themeCode) {
    if (!themeCode) {
        return undefined;
    }
    return themeList.find(theme => caseInsensitiveCompare(theme, themeCode));
}
export function getCachedTheme() {
    var _a;
    return (_a = validateThemeCode(localStorage.getItem(themeStorageKey))) !== null && _a !== void 0 ? _a : defaultTheme;
}
export function setTheme(theme, { shouldBroadcast = true } = {}) {
    var _a;
    const validTheme = (_a = validateThemeCode(theme)) !== null && _a !== void 0 ? _a : defaultTheme;
    if (shouldBroadcast) {
        messageThemeChannel(validTheme);
    }
    localStorage.setItem(themeStorageKey, validTheme);
}
export async function getUserTheme(organizationStandardUrl, token, partitionGlobalId, userId, isMsi) {
    const settingUrl = `${organizationStandardUrl}/${isMsi ? 'identity/api' : 'portal_/api/identity'}/Setting?key=${ApolloSettingKey.UserTheme}&partitionGlobalId=${partitionGlobalId}&userId=${userId}`;
    const settings = await get(settingUrl, { token });
    const theme = getSetting(settings, ApolloSettingKey.UserTheme);
    if (!theme) {
        return null;
    }
    return theme;
}
export async function setUserTheme(theme, organizationStandardUrl, token, partitionGlobalId, userId, isMsi, { shouldBroadcast = true } = {}) {
    var _a;
    const validTheme = (_a = validateThemeCode(theme)) !== null && _a !== void 0 ? _a : defaultTheme;
    if (shouldBroadcast) {
        messageThemeChannel(validTheme);
    }
    localStorage.setItem(themeStorageKey, validTheme);
    const settingsUrl = `${organizationStandardUrl}/${isMsi ? 'identity/api' : 'portal_/api/identity'}/Setting`;
    await put(settingsUrl, {
        token,
        body: {
            settings: [
                {
                    key: ApolloSettingKey.UserTheme,
                    value: validTheme,
                },
            ],
            partitionGlobalId,
            userId,
        },
    });
}
/**
 * @returns The disposer
 */
export function handleThemeChange(callback) {
    const channel = createThemeChannel();
    channel.onmessage = theme => {
        callback(theme);
    };
    return () => {
        channel.close();
    };
}
